import React from 'react';
import { AutoComplete, Input } from 'antd';
import { EDUCATION_LEVEL_OPTIONS } from '../../constants/educationLevels';

// Education level picker grouped by curriculum, which still accepts any level
// that is not on the list. Stores the plain level name, so it behaves like a
// text field for the form and the backend.
const filterLevel = (input, option) =>
  (option?.value ?? '').toLowerCase().includes(input.trim().toLowerCase());

const EducationLevelInput = ({ value, onChange, placeholder, prefix, style, ...rest }) => (
  <AutoComplete
    value={value}
    onChange={onChange}
    options={EDUCATION_LEVEL_OPTIONS}
    filterOption={filterLevel}
    style={{ width: '100%', ...style }}
    {...rest}
  >
    <Input prefix={prefix} placeholder={placeholder} allowClear />
  </AutoComplete>
);

export default EducationLevelInput;
